"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsCtrl = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const mobx_1 = require("mobx");
const services_1 = require("../../services");
const sort_1 = require("../../sort");
class AccountsCtrl {
    constructor() {
        this.loading = mobx_1.observable.map();
    }
    get users() {
        if (services_1.Services.Department.current == null) {
            return [];
        }
        const users = (services_1.Services.UserProfile.list || []).slice();
        sort_1.IkeSort.byKey(users, ['role', 'username'], sort_1.IkeSort.ASC);
        return users;
    }
    get isDepartmentAdmin() {
        for (const account of this.users) {
            if (account.objectId === services_1.Services.User.current.objectId && services_1.Services.UserProfile.isDepartmentAdmin(account)) {
                return true;
            }
        }
        return false;
    }
    get pendingUsers() {
        if (!this.isDepartmentAdmin) {
            return [];
        }
        return services_1.Services.Department.Invite.list || [];
    }
    canRemove(role) {
        return role === core_api_1.IkeUserRole.USER;
    }
    haveExtraRoles() {
        return services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_EXTRA_ROLES) || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE);
    }
    inviteUsers(emails, role) {
        return services_1.Services.Department.Invite.request(emails, role);
    }
    setLoading(objectId, loading) {
        if (loading) {
            this.loading.set(objectId, true);
        }
        else {
            this.loading.delete(objectId);
        }
    }
    removeUserInvite(invite) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.setLoading(invite.objectId, true);
            yield services_1.Services.Department.Invite.revoke(invite.objectId);
            this.setLoading(invite.objectId, false);
        });
    }
    removeUser(user) {
        return this.setRole(user, core_api_1.IkeUserRole.NONE);
    }
    setUserRole(user, role) {
        return this.setRole(user, role);
    }
    setRole(user, role) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const objectId = user.objectId;
            this.setLoading(objectId, true);
            yield services_1.Services.Department.setUserRole(objectId, role);
            this.setLoading(objectId, false);
        });
    }
    isLoadingUser(user) {
        return this.loading.has(user.objectId);
    }
    isLoadingInvite(invite) {
        return this.loading.has(invite.objectId);
    }
}
exports.AccountsCtrl = AccountsCtrl;
tslib_1.__decorate([
    mobx_1.computed
], AccountsCtrl.prototype, "users", null);
tslib_1.__decorate([
    mobx_1.computed
], AccountsCtrl.prototype, "isDepartmentAdmin", null);
tslib_1.__decorate([
    mobx_1.computed
], AccountsCtrl.prototype, "pendingUsers", null);
tslib_1.__decorate([
    mobx_1.action
], AccountsCtrl.prototype, "setLoading", null);
//# sourceMappingURL=accounts.ctrl.js.map